import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import ProfilNavBar from "../../Component/ProfilNavBar/ProfilNavBar";
import NotificationNavbar from "../../Component/NotificationNavbar/NotificationNavbar";
import './LayoutNavSide.css'
import { getDocument } from "../../Firebase";
import avatar from '../../Assets/avatar.png'



function LayoutNavSide() {
  const [userCurrent, setUserCurrent] = useState({});
  const currentUserId = sessionStorage.getItem("user_id");

  useEffect(() => {
    getDocument("users", currentUserId, setUserCurrent)
  }, [currentUserId])
  

  const myphoto = userCurrent?.photo !== undefined? userCurrent?.photo : avatar;

  return (
    <div className="layoutEtud m-0 p-0">
      <nav className="navbar navbar-expand-lg bg-transparent py-3 sticky-top">
        <div className="container-fluid d-flex justify-content-between">
          <div className="d-md-flex coteDroit w-50">
            <img className=" me-md-4" src={myphoto} />
            <div className="mesInfo pt-md-4">
              <h3 className="">{userCurrent?.nom} {userCurrent?.prenom}</h3>
              <p className="capitalize">{userCurrent?.domaine} </p>
            </div>
          </div>
          <div className="d-flex justify-content-end w-50">
            <NotificationNavbar  className='bg-transparent'/>
            <ProfilNavBar />
          </div>
        </div>
      </nav>
      <div className="monOutletEtu">
        <Outlet />
      </div>
    </div>
  );
}

export default LayoutNavSide;
